import { render, staticRenderFns } from "./SoilFertilityConfig.vue?vue&type=template&id=1d4e2002&scoped=true"
import script from "./SoilFertilityConfig.vue?vue&type=script&lang=ts"
export * from "./SoilFertilityConfig.vue?vue&type=script&lang=ts"
import style0 from "./SoilFertilityConfig.vue?vue&type=style&index=0&id=1d4e2002&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d4e2002",
  null
  
)

export default component.exports